import {
    TAUSCHBONUS_LEVEL,
    SAILS_PAGE_OPTIONS,
} from '@vfde-fe/sails-constants';

/**
 * getTauschbonusSoc
 * Get the correct soc by a given device id
 */
export const getTauschbonusSoc = (deviceId: string): string | null => {
    const parsedDeviceId = parseInt(deviceId, 10);

    const { tauschbonus } = window[SAILS_PAGE_OPTIONS].discounts.promotions;

    for (const bonus of TAUSCHBONUS_LEVEL) {
        if (tauschbonus.devices[bonus].includes(parsedDeviceId)) {
            return tauschbonus.socs[bonus];
        }
    }

    return null;
};
